import {RefObject, useEffect} from "react";

const isInsideRefs = (target: Node, refs: RefObject<HTMLElement | null>[]) => refs.some((ref) => ref.current?.contains(target));

export const useClickOutside = (
    ref: RefObject<HTMLElement | null>,
    onClickOutside: () => void,
    deps: unknown[] = [],
    additionalRefs: RefObject<HTMLElement | null>[] = []
) => {
    useEffect(() => {
        const clickOutside = (event: Event) => {
            const refs = [ref, ...additionalRefs];

            if (!isInsideRefs(event.target as Node, refs)) {
                onClickOutside();
            }
        };

        document.addEventListener("mousedown", clickOutside);

        return () => {
            document.removeEventListener("mousedown", clickOutside);
        };
    }, [ref, ...additionalRefs, ...deps]);
};
import {RefObject, useEffect} from "react";

const isInsideRefs = (target: Node, refs: RefObject<HTMLElement | null>[]) => refs.some((ref) => ref.current?.contains(target));

export const useClickOutside = (
    ref: RefObject<HTMLElement | null>,
    onClickOutside: () => void,
    deps: unknown[] = [],
    additionalRefs: RefObject<HTMLElement | null>[] = []
) => {
    useEffect(() => {
        const clickOutside = (event: Event) => {
            const refs = [ref, ...additionalRefs];

            if (!isInsideRefs(event.target as Node, refs)) {
                onClickOutside();
            }
        };

        document.addEventListener("mousedown", clickOutside);

        return () => {
            document.removeEventListener("mousedown", clickOutside);
        };
    }, [ref, ...additionalRefs, ...deps]);
};
